module.exports = __webpack_public_path__ + "static/media/service_assitance_mrh.5343a9db.svg";